import React, { useContext } from 'react';
import Accordion from 'jl-ui-kit/components/accordion/Accordion';
// eslint-disable-next-line import/no-named-as-default
import NavigationItem from '../navigation-item/NavigationItem';
import styles from './mobile-links.scss';
import { getMobileLinks } from '../../../components/links';
import { UserContext } from '../../../scaffold/UserContext';
import EnvVarsFeaturesContext from '../../../scaffold/EnvVarsFeaturesContext';

function MobileNavigationLinks({ navigationV2Active }) {
  const makeMobileLink = (linkInfo, className) => (
    <a
      href={linkInfo.url}
      alt={linkInfo.name}
      className={className}
      key={linkInfo.name}
    >
      {linkInfo.name}
    </a>
  );

  const {
    userState: {
      user: { signedIn },
    },
  } = useContext(UserContext);
  const {
    envVars: { accountBaseUrl },
  } = useContext(EnvVarsFeaturesContext);

  return getMobileLinks(accountBaseUrl).map(item => {
    let { child } = item;

    if (item.authenticatedItems && signedIn) {
      child = item.authenticatedItems;
    }

    if (navigationV2Active) {
      const mobileLinks = { accountHeaderLinks: [], accordionLinks: [] };

      child.forEach(linkItem => {
        if (linkItem.accountHeaderOnly) {
          mobileLinks.accountHeaderLinks.push(
            makeMobileLink(linkItem, styles.mobileAccountHeaderLink)
          );
        } else {
          mobileLinks.accordionLinks.push(
            makeMobileLink(linkItem, styles.accordionLink)
          );
        }
      });

      return (
        <>
          {mobileLinks.accountHeaderLinks.length > 0 && (
            <div className={styles.mobileAccountHeader}>
              {mobileLinks.accountHeaderLinks}
            </div>
          )}
          <Accordion
            label={<h3 className={styles.accordionTitle}>{item.name}</h3>}
            key={item.name}
            className={styles.accordion}
          >
            <ul key={item.name} className={styles.accordionList}>
              {mobileLinks.accordionLinks}
            </ul>
          </Accordion>
        </>
      );
    }

    return (
      <div
        key={item.name}
        className={styles.container}
        data-testid="mobile-navigation-links"
      >
        <h3 className={styles.title}>
          <a href={item.url}>{item.name}</a>
        </h3>
        <ul className={styles.items}>
          {child.map(subitem => (
            <NavigationItem
              key={subitem.name}
              className={styles.mobile}
              {...subitem}
            />
          ))}
        </ul>
      </div>
    );
  });
}

export default MobileNavigationLinks;
